import { DatePipe } from '@angular/common';

export class Utilities {

    static getCurrentMonthWord(){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'MMMM yyyy');
    }

    static getFirstOfCurrentMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    }

    static getLastOfCurrentMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    static getFirstOfLastMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth()-1, 1), 'yyyy-MM-dd');
    }

    static getLastOfLastMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 0), 'yyyy-MM-dd');
    }

    static get12MonthsAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 12);
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    static get6MonthsAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 6);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    static get1MonthAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 1);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }
  
    static getToday() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setDate(date.getDate() + 1);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    static getTodayMinusDays(days: number){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setDate(date.getDate() - days);
        return datepipe.transform(date, 'yyyy-MM-dd');
    } 
    
    static getTodayPlusDays(days: number){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setDate(date.getDate() + days);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    static getDateAsString(date: Date) {
        const datepipe: DatePipe = new DatePipe('en-GB')
        return datepipe.transform(date, "yyyy-MM-dd");
    }

}